<template>
  <div id="datagalaxy">
  	<commonhead ref='commonhead'></commonhead>
  	<main id='maincontentwrap'>
  		<keep-alive>
			<router-view v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive"></router-view>
		<commonfoot></commonfoot>
  	</main>
  	
  </div>
</template>

<script>
		import Bus from '@/bus.js'
	import commonhead from '@/components/commonhead.vue'
	import commonfoot from '@/components/commonfoot.vue'
export default {
  name: 'App',
  components:{
  	commonhead,
  	commonfoot
  },
  mounted(){
  	
  	//动态定位头部位置
//	this.$nextTick(function() {
//		  window.addEventListener('scroll', function(){
//		  	console.log(document.documentElement.scrollLeft)
//		  	document.getElementById('commonhead').style.right= document.documentElement.scrollLeft+'px'; 
//		  });
//	})
	},
}
</script>

<style>
html,body{
	width: 100%;
	height: 100%;
}
#datagalaxy {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  min-width: 1500px;
}
#datagalaxy #maincontentwrap{
	position: relative;
	padding-top: 70px;
	min-height:calc(100% - 115px);
	height:calc(100% - 115px);
	/*box-sizing:border-box;*/
	/*-moz-box-sizing:border-box;*/
	/*-webkit-box-sizing:border-box; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue